/**
 * @generated SignedSource<<897cf5f4f4ce7eeb172f08d402c7c613>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomEditTabs_room$data = {
  readonly media: {
    readonly pageInfo: {
      readonly total: number;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"MediaEditor_mediable" | "RoomEditMain_room">;
  readonly " $fragmentType": "RoomEditTabs_room";
};
export type RoomEditTabs_room$key = {
  readonly " $data"?: RoomEditTabs_room$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomEditTabs_room">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomEditTabs_room",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2147483647
        }
      ],
      "concreteType": "MediaConnection",
      "kind": "LinkedField",
      "name": "media",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "media(first:2147483647)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomEditMain_room"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MediaEditor_mediable"
    }
  ],
  "type": "Room",
  "abstractKey": null
};

(node as any).hash = "f49139c5158c1bc7a52f6b47e7a8d317";

export default node;
